import React, { useContext } from 'react'

import { TabHeader } from '@components/TabHeader'
import { FnaContext } from '../context'

export const Header = () => {
  const { state: { title, filter } } = useContext(FnaContext)
  return (
    <TabHeader title={title}>
      <TabHeader.Filter filter={filter} />
    </TabHeader>
  )
}
